import { render, staticRenderFns } from "./ScarletScreens.vue?vue&type=template&id=2286bfeb&scoped=true"
import script from "./ScarletScreens.vue?vue&type=script&lang=js"
export * from "./ScarletScreens.vue?vue&type=script&lang=js"
import style0 from "./ScarletScreens.vue?vue&type=style&index=0&id=2286bfeb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2286bfeb",
  null
  
)

export default component.exports